import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { getAppPath } from "services/app-path.service";

function PublicTopNav() {
  const linkColor = "#0f172a";

  return (
    <SoftBox
      position="relative"
      zIndex={20}
      py={1.25}
      sx={{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
      }}
    >
      <Container>
        <SoftBox display="flex" alignItems="center" justifyContent="space-between" gap={2}>
          <a href="/" aria-label="RBR Analytics home">
            <img
              src="/img/RBR_logo_colour.png"
              alt="RBR Analytics logo"
              style={{ height: "48px", display: "block" }}
            />
          </a>

          <SoftBox display="flex" alignItems="center" gap={{ xs: 1.5, sm: 2.5 }} flexWrap="wrap">
            <Link underline="none" color={linkColor} href="/">
              Home
            </Link>
            <Link underline="none" color={linkColor} href={getAppPath("/applications/new_process")}>
              Assessment
            </Link>
            <Link underline="none" color={linkColor} href={getAppPath("/dashboards/pricing")}>
              Pricing
            </Link>
            <SoftButton
              component="a"
              href={getAppPath("/authentication/login")}
              size="small"
              variant="gradient"
              color="dark"
            >
              Log In
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </Container>
    </SoftBox>
  );
}

export default PublicTopNav;
